import "./_import_files";

import svg4everybody from "svg4everybody";
import $ from "jquery";
import Page from "webPage/Page";
import "objectFitPolyfill";
import StickyNav from "StickyNav";
import PageAnimations from "webPage/PageAnimations";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import {animation} from "gsap";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";


$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    new StickyNav($(".header"), $(".hero"));

    $('body').on('click', '.js-nav-btn', function () {
        $('body').toggleClass('nav-active');
        $('.js-nav-btn').toggleClass('nav-btn--close');
    });

    PageAnimations.start();
    svg4everybody();
    Page.init();
    setTimeout(objectFitPolyfill);

    $(".js-subscribe-form").each(function () {
        FormValidator.attach($(this), {
            inputOptions: {operator: 'your'}
        }).on("input:invalid", ({input}) => {
            input.$input.parents(".form__row").first().addClass("form__row--error");
        }).on("input:valid", ({input}) => {
            input.$input.parents(".form__row").first().removeClass("form__row--error");
        }).on("submit", ($form) => {
            let $btn = $form.find("button[type=submit]");
            if ($btn.is(".loading")) return;
            $btn.addClass("loading");
            $('.subscribe').addClass('subscribe--loading');


            Ajax.post("opus", "subscribe", $form.serializeJSON(), Ajax.WEBSITE).then((data) => {
                $('.subscribe').removeClass("subscribe--loading");
                $btn.removeClass("loading");

                $('.footer__subscribe').html('').append(
                    eotwJSXFactory('div', {className: "subscribe__section subscribe__section--success"}, [
                        eotwJSXFactory('span', {className: "subscribe__icon svg-icons"}).html('<svg><use xlink:href="/includes/svg-icons.svg#success-white"></use></svg>'),
                        eotwJSXFactory('div', null, [
                            eotwJSXFactory('h4', null, ["Thanks for subscribing"]),
                            eotwJSXFactory('p', null, ["You have successfully subscribed to our newsleter. Please check your inbox."])
                        ])
                    ])
                );

                $('.js-news-subscribe').html('').append(
                    eotwJSXFactory('div', {className: "subscribe__wrapper"}, [
                        eotwJSXFactory('div', {className: "subscribe__section subscribe__section--success"}, [
                            eotwJSXFactory('span', {className: "subscribe__icon svg-icons"}).html('<svg><use xlink:href="/includes/svg-icons.svg#success-white"></use></svg>'),
                            eotwJSXFactory('h3', null, ["Thanks for subscribing"]),
                            eotwJSXFactory('hr', {className: "subscribe__line"}),
                            eotwJSXFactory('p', null, ["You have successfully subscribed to our newsleter. Please check your inbox."])
                        ])
                    ])
                );

            }).catch((e) => {
                $('.subscribe').removeClass('subscribe--loading');
                $btn.removeClass("loading");
                if (e.data && e.data.exception === 'HttpValidationException') {
                    $form.data("Validator").handleValidationException(e);
                } else {
                    console.log(e.message);
                }

                $('.footer__subscribe').html('').append(
                    eotwJSXFactory('div', {className: "subscribe__section subscribe__section--error"}, [
                        eotwJSXFactory('span', {className: "subscribe__icon svg-icons"}).html('<svg><use xlink:href="/includes/svg-icons.svg#error-white"></use></svg>'),
                        eotwJSXFactory('div', null, [
                            eotwJSXFactory('h4', null, ["There was a problem"]),
                            eotwJSXFactory('p', null, ["Sorry, we couldn’t add you to our newsletter at this time. Please try later."])
                        ])
                    ])
                );

                $('.js-news-subscribe').html('').append(
                    eotwJSXFactory('div', {className: "subscribe__wrapper"}, [
                        eotwJSXFactory('div', {className: "subscribe__section subscribe__section--error"}, [
                            eotwJSXFactory('span', {className: "subscribe__icon svg-icons"}).html('<svg><use xlink:href="/includes/svg-icons.svg#error-white"></use></svg>'),
                            eotwJSXFactory('h3', null, ["There was a problem"]),
                            eotwJSXFactory('hr', {className: "subscribe__line"}),
                            eotwJSXFactory('p', null, ["Sorry, we couldn’t add you to our newsletter at this time. Please try later."])
                        ])
                    ])
                );
            });
        });
    });
});

export function scrollMagicActive() {
    return $(window).outerWidth() >= 960;
}
